import React from 'react'

const Notfound = () => {
  return (
    <div className='text-center my-5'>
      <h1>Page not found</h1>
      
    </div>
  )
}

export default Notfound